import { Check } from 'lucide-react';
import type * as React from 'react';
import { cn } from './lib/cn';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
  /** Uma linha abaixo do rotulo, para o que o nome nao explica. */
  hint?: string;
  /**
   * Marcado e sem escolha - nao desligado.
   *
   * `disabled` apaga o rotulo junto, e apagado quer dizer "isto nao vale
   * agora". Aqui vale sempre: e o texto precisa continuar legivel.
   */
  locked?: boolean;
}

/**
 * Marcador do sistema. O quadrado e desenhado, nao o nativo: o do navegador
 * muda de cara em cada sistema operacional e ignora a cor do tema.
 */
export function Checkbox({ className, label, hint, disabled, locked, ...props }: CheckboxProps) {
  return (
    <label
      className={cn(
        'flex items-start gap-2 text-sm',
        locked ? 'cursor-default' : disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className,
      )}
    >
      <span className="relative flex h-5 w-5 shrink-0 items-center justify-center">
        <input
          type="checkbox"
          disabled={disabled || locked}
          className={cn('peer sr-only', locked && 'opacity-50')}
          {...props}
        />
        <span
          aria-hidden
          className="flex h-5 w-5 items-center justify-center rounded border border-border-strong bg-card text-transparent transition-colors peer-checked:border-primary peer-checked:bg-primary peer-checked:text-primary-foreground peer-focus-visible:ring-2 peer-focus-visible:ring-primary/30"
        >
          <Check className="h-3.5 w-3.5" />
        </span>
      </span>

      {label ? (
        <span className="min-w-0">
          <span className="block leading-5">{label}</span>
          {hint ? <span className="block text-xs text-muted-foreground">{hint}</span> : null}
        </span>
      ) : null}
    </label>
  );
}
